import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import { STATUS_STYLE } from './StatusBadge';

const Filter = ({ statusFilter, setStatusFilter }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
      {['', 'pending', 'partially_signed', 'completed', 'declined', 'expired', 'cancelled'].map(s => (
        <button
          key={s}
          onClick={() => setStatusFilter(s)}
          style={{
            padding: '6px 14px',
            borderRadius: 20,
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            background: statusFilter === s ? S.burgundy : S.bgCard,
            color: statusFilter === s ? '#fff' : S.textSecondary,
            border: `1px solid ${statusFilter === s ? S.burgundy : S.borderLight}`,
          }}
        >
          {s === '' ? t('screens.esign.filterAll') : (STATUS_STYLE[s]?.tKey ? t(STATUS_STYLE[s].tKey) : s)}
        </button>
      ))}
    </div>
  );
};

export default Filter;
